/**
 * Cached fetch of raftor_websitehq.website_hq.attribute_sets.icons: {attribute: {value: icon address}} for every attribute a site shows as
 * Icons. The card adapter (adapters/webshop.js) treats such an attribute like Colour: its values are swatches (here icons, not colours), in the
 * swatch position on the left, with the size dropdown on the right. Same contract as swatch_color_overrides.js: one call per page, shared by
 * every source, and a failed or absent call resolves to {} so a card never fails over a decoration.
 */

let cachedPromise = null;

export function getAttributeIcons() {
	if (!cachedPromise) {
		cachedPromise = new Promise((resolve) => {
			if (typeof frappe === 'undefined' || !frappe.call) {
				resolve({});
				return;
			}
			let settled = false;
			const done = (value) => {
				if (settled) return;
				settled = true;
				resolve(value && typeof value === 'object' ? value : {});
			};
			frappe.call({
				method: 'raftor_websitehq.website_hq.attribute_sets.icons',
				type: 'POST',
				callback: (r) => done(r && r.message),
				error: () => done({}),
			});
			setTimeout(() => done({}), 8000);
		});
	}
	return cachedPromise;
}
